import { render, staticRenderFns } from "./MemberListV2Component.vue?vue&type=template&id=28f59a40&"
import script from "./MemberListV2Component.vue?vue&type=script&lang=js&"
export * from "./MemberListV2Component.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports